import { render } from "./MMMultilateralAdvisors.vue?vue&type=template&id=b24c7b88"
import script from "./MMMultilateralAdvisors.vue?vue&type=script&lang=js"
export * from "./MMMultilateralAdvisors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__